import type { ComponentProps } from "react";
import { Dialog } from "../../components/index.tsx";
import { ErrorScreen, LoadingScreen } from "../../screens/index.ts";
import { GameHistoryTable } from "./components/GameHistoryTable.tsx";
import { useGameHistory } from "./hooks/use-game-history.ts";

export const GameHistoryDialog = (
  props: Omit<ComponentProps<typeof Dialog.Content>, "children">,
) => {
  const gameHistoryQuery = useGameHistory();

  if (gameHistoryQuery.isPending) {
    return <LoadingScreen />;
  }

  if (gameHistoryQuery.isError) {
    return <ErrorScreen error={gameHistoryQuery.error} />;
  }

  const gameHistory = gameHistoryQuery.data;

  return (
    <Dialog.Content {...props} size="fullscreen">
      <Dialog.Header>Game History</Dialog.Header>
      <Dialog.Body>
        <GameHistoryTable history={gameHistory} />
      </Dialog.Body>
    </Dialog.Content>
  );
};
